import { Tooltip as ChakraTooltip } from "@chakra-ui/tooltip";

// Chakra runs headless (no theme), so the positioner's stacking order has to
// be supplied here; it sits above dialogs and drawers.
const STYLE_CONFIG = { baseStyle: { zIndex: 1800 } };

/**
 * Tooltip — short hint shown on hover and on keyboard focus (Esc closes).
 *
 * `trigger` must be a single element that can hold focus and forwards its ref
 * (e.g. `<button>`, `<Link>`, `IconButton`); focus on a nested child does not
 * open it. The tooltip is linked to the trigger through `aria-describedby`.
 *
 * @param {object} props
 * @param {React.ReactElement} props.trigger Element the tooltip describes.
 * @param {React.ReactNode} props.content Tooltip text; nothing renders when empty.
 * @param {"top"|"right"|"bottom"|"left"|string} [props.placement="top"] Popper placement.
 * @param {string} [props.extra] Extra classes for the tooltip bubble.
 * Other Chakra Tooltip props (openDelay, isDisabled, …) are forwarded.
 */
export const Tooltip = ({
  trigger,
  content,
  placement = "top",
  extra,
  ...rest
}) => (
  <ChakraTooltip
    placement={placement}
    label={content}
    styleConfig={STYLE_CONFIG}
    className={`max-w-xs rounded-md bg-navy-900 px-2 py-1 text-xs font-medium text-white shadow-overlay ${
      extra || ""
    }`}
    {...rest}
  >
    {trigger}
  </ChakraTooltip>
);

export default Tooltip;
